<template>
  <div>
    <div class="title">
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#icon-invoice"></use>
      </svg>
      <span>日记账认领</span>
    </div>
    <div class="boxcnt">
      <van-collapse v-model="activeName" @change="changeActive" accordion>
        <van-collapse-item v-for="(company, index) in dayBookdetailList" :key="index" :name="index">
           <template #title>
            <div class="flex-align"><van-icon name="wap-home" color="#1989fa" size="0.5rem" style="margin-right: 5px;"/>
              <div class="width_300 van-ellipsis">{{company.companyName}}</div>
            </div>
          </template>
          <van-row class="fl">
            <van-col span="24">
              <van-collapse v-model="activeName2" @change="changeActive2" style="margin-top:0px">
                <van-collapse-item v-for="(dayBookdetail, index) in company.finaDaybookDetailedList" :key="index" :name="'detail'+index">
                  <template #title>
                    <div class="flex-align"><van-icon name="friends" color="#1989fa" size="0.5rem" style="margin-right: 5px;"/>
                      <div class="width_300 van-ellipsis">{{dayBookdetail.custName}}</div>
                    </div>
                  </template>
                  <van-row class="fl">
                    <van-col span="18">
                      <div class="section van-hairline--top">
                        <div class="cont">
                          <van-row>
                            <van-col span="24">
                              <div class="flex-mb8">
                                <span class="key">银行名称：</span>
                                <span class="value van-ellipsis">{{ dayBookdetail.bankName }}</span>
                              </div>
                            </van-col>
                          </van-row>
                          <van-row>
                            <van-col span="24">
                              <div class="flex-mb8">
                                <span class="key">发生金额：</span>
                                <span class="value van-ellipsis">{{dayBookdetail.paymentMoney}}</span>
                              </div>
                            </van-col>
                          </van-row>
                          <van-row>
                            <van-col span="24">
                              <div class="flex-mb8">
                                <span class="key">收支类型：</span>
                                <span class="value van-ellipsis">{{ dayBookdetail.incomePayTypeName }}</span>
                              </div>
                            </van-col>
                          </van-row>
                          <van-row>
                            <van-col span="24">
                              <div class="flex-mb8">
                                <span class="key">收支状态：</span>
                                <span class="value van-ellipsis">{{balanceStatusFormat(dayBookdetail.balanceStatus)}}</span>
                              </div>
                            </van-col>
                          </van-row>
                          <van-row>
                            <van-col span="24">
                              <div class="flex-mb8">
                                <span class="key">交易流水号：</span>
                                <span class="value van-ellipsis">{{dayBookdetail.serialNum }}</span>
                              </div>
                            </van-col>
                          </van-row>
                        </div>
                      </div>
                    </van-col>
                    <van-col span="6">
                      <div>
                        <van-button v-if="dayBookdetail.claimStatus == '0'" size="small" type="info" style="border-radius: 4px;padding: 0 20px;" @click="showPop(dayBookdetail)">认领</van-button>
                        <van-button v-if="dayBookdetail.claimStatus == '1'" size="small" type="primary" style="border-radius: 4px;padding: 0 20px;">（{{dayBookdetail.claimUserName}}）已认领</van-button>
                      </div>
                    </van-col>
                  </van-row>
                </van-collapse-item>
              </van-collapse>
            </van-col>
          </van-row>
        </van-collapse-item>
      </van-collapse>
    </div>
    <van-dialog v-model="popshow" title="日记账认领" :beforeClose="beforeClose" close-on-click-overlay width="95%" style="height:46%;overflow: auto;">
      <van-form ref="selectDayBookdetail" validate-trigger="onSubmit" class="group">
        <van-cell-group>
          <van-field readonly label="公司名称" v-model="selectDayBookdetail.companyName"/>

          <van-field readonly clickable v-model="selectDayBookdetail.businessTypeName" @click="showPicker('business')" label="选择产品类型" placeholder="请选择产品类型" :rules="[{ required: true }]" required />
          <!-- <van-field readonly clickable v-model="selectDayBookdetail.companyName" @click="showPicker('company')" label="选择公司" placeholder="请选择公司" :rules="[{ required: true }]"  required /> -->
          <van-field readonly clickable v-model="selectDayBookdetail.deptName" @click="showPicker('dept')" label="选择部门" placeholder="请选择部门" :rules="[{ required: true }]" required />
          <van-field readonly clickable v-model="selectDayBookdetail.nickName" @click="showPicker('user')" label="选择认领人" placeholder="请选择认领人" :rules="[{ required: true }]" required />
        </van-cell-group>
      </van-form>
    </van-dialog>
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup>
  </div>
</template>

<script>

import { List, Cell, Button, Tag, Dialog, Area, Toast, Icon, Field, Col, Row, CellGroup, Popup, Picker, Radio, RadioGroup, Grid, GridItem, Tab, Tabs, Form, Calendar,Collapse, CollapseItem  } from 'vant'
import {getDayBookDetailed,updateDetailed,getMobileList} from "@/api/fina/invoice";
import { mapGetters } from "vuex";
import { selectAllBusinessType } from "@/api/scrm/custbusinesstype";
import { handleTree } from "@/utils/util";
import { treeselect } from "@/api/system/dept";
import { listUser } from "@/api/admi/user";

export default {
  computed: {
    ...mapGetters({
      userinfo: "userinfo",
    }),
  },
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Form.name]: Form,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Area.name]: Area,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Form.name]: Form,
    [Calendar.name]: Calendar,
    [Collapse.name]: Collapse,
    [CollapseItem .name]: CollapseItem,
  },
  data() {
    return {
      picker: {
        visible: false,
        title: "",
        columns: [],
        formKey: "",
      },
      popshow:false,
      dayBookdetail: {
        claimStatus:'0'
      },
      dayBookdetailList:[],
      selectDayBookdetail:{
        businessTypeName:'',
        company:'',
        deptName:'',
        nickName:'',
      },
      balanceStatusOptions:{},
      claimStatusOptions:{},
      // 产品类型树选项
      businessTypeOptions:[],
      activeName:['1'],
      activeName2:[],
      companyOptions:[],
      deptOptions:[],
      userOptions:[]
    }
  },
  mounted() {
    //认领状态
    this.getDicts("claim_status").then(response => {
      this.claimStatusOptions = response.data; 
    });
    //收支状态
    this.getDicts("balance_status").then(response => {
      this.balanceStatusOptions = response.data; 
    });
    
    selectAllBusinessType().then(res => {
      this.businessTypeOptions = handleTree(res.data, "businessTypeId");
    });
    this.init()
    // this.getUserList();
  },
  methods: {
    async init() {
      //修改主体框架标题
      document.title = "FINA-日记账认领";
      getMobileList({claimStatus:0}).then((response) => {
        this.dayBookdetailList = response.rows || [];
      });
    },
    changeActive() {
      this.activeName2 = [];
    },
    changeActive2(e) {
      // alert(e)
    },
    showPop(dayBookdetail) {
      this.selectDayBookdetail = {}
      this.selectDayBookdetail = dayBookdetail;
      this.getTreeselect(this.selectDayBookdetail.companyId);
      this.popshow = true;
    },
    showPicker(type) {
      this.picker.formKey = type
      if (type === "business") {
        this.picker.columns = this.businessTypeOptions.map(ele => this.businessNormalizer(ele))
      }
      if (type === "company") {
        this.picker.columns = this.companyOptions.map(ele => ele.label)
      }
      if (type === "dept") {
        this.picker.columns = this.deptOptions.map(ele => this.deptNormalizer(ele))
      }
      if (type === "user") {
        this.picker.columns = this.userOptions.map((ele) => ele.nickName);
      }
      this.picker.visible = true;
    },
    pickerConfirm(value, index) {
      if (this.picker.formKey === "business") {
        if (value.length == 2) {
          if (value[1].length > 0) {
            this.selectDayBookdetail.businessTypeName = value[0] + '/' + value[1]
            let obj = this.businessTypeOptions.find(item => item.businessTypeName === value[0])
            if (obj != null) {
              this.selectDayBookdetail.businessTypeId = obj.children.find(item => item.businessTypeName === value[1]).businessTypeId
            }
          }
        } else {
          this.selectDayBookdetail.businessTypeName = value[0]
          let obj = this.businessTypeOptions.find(item => item.businessTypeName === value[0])
          if (obj != null) {
            this.selectDayBookdetail.businessTypeId = obj.businessTypeId
          }
        }
      }
      if (this.picker.formKey === "dept") {
         if (value.length == 2) {
          if (value[1].length > 0) {
            this.selectDayBookdetail.deptName = value[0] + '/' + value[1]
            let obj = this.deptOptions.find(item => item.label === value[0])
            if (obj != null) {
              this.selectDayBookdetail.deptId = obj.children.find(item => item.label === value[1]).id
              this.getUserList(this.selectDayBookdetail.deptId);
              this.selectDayBookdetail.claimUserId = ''
              this.selectDayBookdetail.nickName = ''
            }
          }
        } else {
          this.selectDayBookdetail.deptName = value[0]
          let obj = this.deptOptions.find(item => item.businessTypeName === value[0])
          if (obj != null) {
            this.selectDayBookdetail.deptId = obj.id
            this.getUserList(obj.id);
          }
        }
      }
      if (this.picker.formKey === "user") {
        let obj = this.userOptions.find(item => item.nickName === value)
        if (obj != null) {
          this.selectDayBookdetail.claimUserId = obj.userId
          this.selectDayBookdetail.nickName = obj.nickName
        }
      }
      if (this.picker.formKey === "company") {
        let obj = this.companyOptions.find(item => item.label === value)
        if (obj != null) {
          this.selectDayBookdetail.companyId = obj.id
          this.selectDayBookdetail.company = obj.label
        }
      }
      this.picker.visible = false;
    },

    pickerCancel() {
      this.picker.visible = false;
    },
    /** 查询部门下拉树结构 */
    getTreeselect(id) {
      treeselect().then(response => {
        let datalist = response.data || []
        this.deptOptions = []
        for (let i = 0; i < datalist.length; i++) {
          const element = datalist[i];
          if(element.id == id){
            if(element.children && element.children.length >0){
              for (let y = 0; y < element.children.length; y++) {
                const ele = element.children[y];
                if(ele.children && ele.children.length >0){
                  this.deptOptions = element.children
                }
              }
            }
          }
        }
      });
    },
    getUserList(deptId) {
      // let deptId = this.userinfo.dept.deptId;
      let querys = {
        deptId:deptId,
      }
      listUser(querys).then(response => {
        this.userOptions = response.rows ||[]
      });
    },
    /** 转换产品类型数据结构 */
    businessNormalizer(node) {
      let arr = []
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            id: node.children[i].businessTypeId,
            text: node.children[i].businessTypeName
          }
          arr.push(item)
        }
      }
      return {
        id: node.businessTypeId,
        text: node.businessTypeName,
        children: arr
      };
    },
    deptNormalizer(node) {
      let arr = []
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            id: node.children[i].id,
            text: node.children[i].label
          }
          arr.push(item)
        }
      }
      return {
        id: node.id,
        text: node.label,
        children: arr
      };
    },
    balanceStatusFormat(balanceStatus) {
      return this.selectDictLabel(this.balanceStatusOptions, balanceStatus);
    },
    invoiceTypeFormat(row, column) {
      return this.selectDictLabel(this.invoiceTypeOptions, row.invoiceType);
    },
    confirmHandle(dayBookdetail) {
      let params = {
        'daybookDetailedId':dayBookdetail.daybookDetailedId || '',
        'claimUserId':dayBookdetail.claimUserId,
        'businessTypeId':dayBookdetail.businessTypeId || '',
        'businessTypeName':dayBookdetail.businessTypeName || '',
      }
      updateDetailed(params).then((response) => {
        Toast.success("认领成功");
        this.init();
        this.popshow = false;
        this.activeName2 = [];
      });
    },
    formatDate(date) { // 时间格式化 2019-09-08
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return year + '-' + month + '-' + day
    },
    // 认领
    async beforeClose(type, done) {
      if (type === "confirm") {
        if(this.selectDayBookdetail.claimUserId){//认领人已选择
          try {
            this.confirmHandle(this.selectDayBookdetail);
            return done();
          } catch (err) {
            return done(false);
          }
        }else{
          Toast.fail("请选择认领人");
          return done(false);
        }
      } else {
        return done();
      }
      
    },
  }
}
</script>

<style lang="less" scoped>
  .boxcnt{
    height: 15.78rem;
    overflow: auto;
    margin-top: 0.25rem;
  }
  .boxcnt ::v-deep .van-collapse-item__content {
    padding: 0 0.42667rem;
    color: #969799;
    font-size: 0.37333rem;
    line-height: 1.5;
    background-color: #fff;
  }
  .fl{
    display: flex;
    align-items: center;
  }
  .title{
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    margin: 30px 0 0 30px;
    span{
      font-size: 32px;
      margin-left: 5px;
    }

    .icon {
      display: inline-block;
      width: 40px;
      height: 40px;
    }
  }
  .panleTitle{
    margin-top: 30px;
    height: 60px;
    display: block;
    line-height: 65px;
    margin-left: 20px;
    font-size: 32px;
    text-align: left;
  }
  .panleBox_bf{
    width: 92%;
    font-size: 18px;
    margin:5% 0 0 26px;
    border: 3px solid #f3d6a6;
    border-radius: 20px;
    min-height: 500px;
  }
  .panleBox_last{
    width: 92%;
    font-size: 18px;
    margin:5% 0 0 26px;
    border: 3px solid #39bb77;
    border-radius: 20px;
    min-height: 500px;
  }
  .section {
    // padding-top: 0.26667rem;
    font-size: 0.37333rem;
    color: #999;
    // margin: 10px 0 10px 25px;
    // box-shadow: -10px 10px 10px #cfdbe9;
    // background-color: #f9f9f9;
  }
  .flex-mb8 {
    display: flex;
    margin-bottom: 10px;
    height: 40px;
    line-height: 40px;
  }
  .cont{
    padding:  10px;
  }
  .key{
    font-size: 0.38rem;
    color: #333;
    // width: 2rem;
    text-align: left;
  }
  .value{
    font-size: 0.38rem;
    color: #666;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // display: -webkit-box;
    // -webkit-box-orient: vertical;
    // -webkit-line-clamp:1 ;
    max-width: 4.6rem;
  }
  .flex-align{    
    display: flex;
    align-items: center;
  }
  .width_300{width: 7rem;}
  .group{
    // min-height: 3.25rem;
    margin: 0.4rem 0.4em;
  }
</style>
